const {Octokit} = require("@octokit/core")
let octokit

/**
 * @param {String} githubPersonalAccessToken
 * @param {Object} options
 * @param {String} options.owner
 * @param {String} options.repo
 * @param {String} [options.state]
 * @param {String} [options.head]
 * @param {String} [options.base]
 * @param {String} [options.sort]
 * @param {String} [options.direction]
 * @param {String} [options.per_page]
 * @param {String} [options.page]
 *
 * @see https://docs.github.com/en/rest/pulls/pulls#list-pull-requests
 */
async function listPullRequests(githubPersonalAccessToken, options) {

    console.log("Getting all PRs for repository:", options.repo)

    if (!githubPersonalAccessToken) {
        console.error("GitHub access token is empty!")
    }

    if (!octokit) {
        octokit = new Octokit({
            auth: githubPersonalAccessToken
        })
    }


    return octokit.request('GET /repos/{owner}/{repo}/pulls', {
        owner: options.owner,
        repo: options.repo,
        state: options.state || "all",
        head: options.head,
        base: options.base,
        sort: options.sort,
        direction: options.direction,
        per_page: options.per_page,
        page: options.page,
    })
}


/**
 * @param {String} githubPersonalAccessToken
 * @param {Object} options
 * @param {String} options.owner
 * @param {String} options.repo
 * @param {number} options.pull_number
 *
 * @see https://docs.github.com/en/rest/pulls/pulls#get-a-pull-request
 */
async function getAPullRequest(githubPersonalAccessToken, options) {

    if (!octokit) {
        octokit = new Octokit({
            auth: githubPersonalAccessToken
        })
    }

    return octokit.request('GET /repos/{owner}/{repo}/pulls/{pull_number}', {
        owner: options.owner,
        repo: options.repo,
        state: options.pull_number
    })
}


/**
 * @param {String} githubPersonalAccessToken
 * @param {String} headSHA
 * @param {Object} options
 * @param {String} options.owner
 * @param {String} options.repo
 * @param {String} [options.state]
 * @param {String} [options.head]
 * @param {String} [options.base]
 * @param {String} [options.sort]
 * @param {String} [options.direction]
 * @param {String} [options.per_page]
 * @param {String} [options.page]
 *
 * @see https://docs.github.com/en/rest/pulls/pulls#list-pull-requests
 */
async function getAPullRequestByHeadSHA(githubPersonalAccessToken, headSHA, options) {

    console.log("Getting the data for pull request: {\n" + "Head commit SHA1: " + headSHA + "\n" + "Repository: " + options.repo + "\n}")

    if (!githubPersonalAccessToken) {
        console.error("GitHub access token is empty!")
    }

    if (!octokit) {
        octokit = new Octokit({
            auth: githubPersonalAccessToken
        })
    }

    const prList = await listPullRequests(githubPersonalAccessToken, options)

    console.log(`Returned ${prList.data.length} pull requests`)

    for (const item of prList.data) {
        if (item.merge_commit_sha === headSHA) {
            console.log("Returned pull request data: \n", JSON.stringify(item))
            return item
        }
    }
}


/**
 * @param {String} githubPersonalAccessToken
 * @param {Object} options
 * @param {String} options.owner
 * @param {String} options.repo
 * @param {String} options.workflow_id_or_name
 * @param {String} options.ref
 * @param {Object} [options.inputs]
 *
 * @see https://docs.github.com/en/rest/actions/workflows#create-a-workflow-dispatch-event
 */
async function createWorkflowDispatchEvent(githubPersonalAccessToken, options) {

    if (!githubPersonalAccessToken) {
        console.error("GitHub access token is empty!")
    }

    if (!octokit) {
        octokit = new Octokit({
            auth: githubPersonalAccessToken
        })
    }

    return octokit.request('POST /repos/{owner}/{repo}/actions/workflows/{workflow_id}/dispatches', {
        owner: options.owner,
        repo: options.repo,
        workflow_id: options.workflow_id_or_name,
        ref: options.ref,
        inputs: options.inputs
    })
}

/**
 * @param {String} githubPersonalAccessToken
 * @param {Object} options
 * @param {String} options.owner
 * @param {String} options.repo
 * @param {String} options.event_type
 * @param {String} [options.client_payload]
 *
 * @see https://docs.github.com/en/rest/repos/repos#create-a-repository-dispatch-event
 */
async function createRepositoryDispatchEvent(githubPersonalAccessToken, options) {

    if (!githubPersonalAccessToken) {
        console.error("GitHub access token is empty!")
    }

    if (!octokit) {
        octokit = new Octokit({
            auth: githubPersonalAccessToken
        })
    }

    return octokit.request('POST /repos/{owner}/{repo}/dispatches', {
        owner: options.owner,
        repo: options.repo,
        event_type: options.event_type,
        client_payload: options.client_payload
    })
}


module.exports = {
    listPullRequests,
    getAPullRequest,
    getAPullRequestByHeadSHA,
    createWorkflowDispatchEvent,
    createRepositoryDispatchEvent
}